// extracted by mini-css-extract-plugin
export default {"container":"Dh9mV","time":"_2FQHI","title":"_2rNm9","chevron":"_3VHN-"};